import { Relationship } from "@resource/models";

interface Props {
  relationships: Relationship[];
  organizationId: string;
}

export const RelationshipTypeCellContent = (props: Props) => {
  const { relationships, organizationId } = props;

  const filtered = relationships.filter(e => {
    return e.entityId === organizationId.toLowerCase();
  });

  const mapped = filtered.map(e => e.relationshipType);
  const relationshipTypes = mapped.join("; ");

  return <span>{relationshipTypes}</span>;
};
